<template>
    <main>
      <div class="login-panel">
                <div class="top-page-divider">
                    <h3 class="page-title center">Welcome to Xalor</h3>
                </div>
                <p class="success-message m-auto mb-4"><i class="fas fa-check-circle mr-1"></i>Account Successfully Created!</p>
                <p>You can now begin your adventure on Xalor!</p>
                <div class="welcome-page--icon mt-4 mb-4">
                    <img src="@/assets/img/welcome-icon.png" eager>
                </div>
                <router-link to="/login" class="btn large mb-4">Login to your account</router-link>
                <p>Ready to get started? <router-link to="/play">Download Xalor</router-link>.</p>
      </div>
    </main>
</template>
<script setup lang="ts">
</script>